import { render, staticRenderFns } from "./AskSection.vue?vue&type=template&id=dc6ebf1e&scoped=true"
import script from "./AskSection.vue?vue&type=script&lang=js"
export * from "./AskSection.vue?vue&type=script&lang=js"
import style0 from "./AskSection.vue?vue&type=style&index=0&id=dc6ebf1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6ebf1e",
  null
  
)

export default component.exports